import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'format'
})
@Injectable({ providedIn: 'root' })
export class FormatPipe implements PipeTransform {

  transform(template: string, values: { [key: string]: any }): string {
    return template.replace(/\{\{(\w+)\}\}/g, (_, key) => values[key] || '');
  }
}
